"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.unwrapSingleTag = void 0;
/**
 * Removes a single wrapping html tag around html content, only if there is one such tag
 * Particularly useful for retaining markdown formatting in a title, but removing the
 * unwanted <p> tag, for injection into a more appropriate <h1>, <h2>, etc tag instead.
 */
var unwrapSingleTag = function (html, tag) {
  if (tag === void 0) {
    tag = 'p';
  }
  var matches = html.match(new RegExp("<".concat(tag, ">[\\s\\S]*</").concat(tag, ">"), 'ig'));
  if (matches && matches.length === 1) {
    return html.replace(new RegExp("<".concat(tag, ">([\\s\\S]*)</").concat(tag, ">"), 'i'), "$1");
  }
  return html;
};
exports.unwrapSingleTag = unwrapSingleTag;